import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { FileUpload } from 'primeng/fileupload';
import { init } from '../editorconfig';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-idex-response',
  standalone: false,
  templateUrl: './idex-response.component.html',
  styleUrl: './idex-response.component.scss',
})
export class IdexResponseComponent implements OnInit {
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  challengeForm!: FormGroup;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Input() step: any;
  @Input() id: any;
  @Input() schemeType: any;
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Input() data: any[] = [];
  userID: any;
  vendorForm!: FormGroup;
  uploadedCsvFile: File | null = null;
  finalOfferFilePath: string | null = null;
  apiUrl = environment.APIUrl;
  uploadedFileName: null;
  selectedFinalOfferFile: File | null = null;
  uploadedUrl: any;
  file: File;
  csvfile: File;
  vendorData: any;
  vendors: any[] = [];
  allDmsFiles:any[]=[];
  private subscriptions = new Subscription();

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private uploadService: UploadService,
    private messageService: MessageService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnInit() {
    this.getTableData();
  }
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
    expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };
  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    // formData.append('proposal_step',this.stepId);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);
    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })
    // Optionally call delete API
  }
  addVendor() {
    const newVendor = {
      id: null,
      name: '',
      company_name: '',
      email: '',
      contact: '',
      phone_number: '',
      address: '',
      tax_number: '',
      bank_details: '',
      document: null,
      isEditing: true,
    };

    this.vendors.push(newVendor);
  }

  removeVendor(vendor: any) {
    vendor.isEditing = false;
  }

  toggleEdit(vendor: any) {
    vendor.isEditing = true;
  }

  onSelectFile(event: any, vendor: FormGroup) {
    const file = event.files?.[0];
    this.file = file;
    if (!file) return;
  }

  saveVendor(vendor: any) {
    vendor.isEditing = false;

    const payload = vendor;
    const formData = new FormData();

    formData.append('step', this.vendorData.id);
    formData.append('name', payload.name);
    formData.append('company_name', payload.company_name);
    formData.append('email', payload.email);
    formData.append('contact', payload.contact);
    formData.append('phone_number', payload.phone_number);
    formData.append('address', payload.address);
    formData.append('tax_number', payload.tax_number);
    formData.append('bank_details', payload.bank_details);

    if (this.file) {
      formData.append('document', this.file);
    }

    const isExisting = !!payload.id; // Check if vendor has an ID
    if (isExisting) {
      formData.append('id', payload.id);
    }

    const request = isExisting
      ? this.api.putAPI(`/idex/vendor-details/`, formData)
      : this.api.postAPI(`/idex/vendor-details/`, formData);

    const sub = request.subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: isExisting
            ? 'Vendor updated successfully'
            : 'Vendor added successfully',
        });
        this.getTableData(); // refresh the table
      },
      error: (err) => {
        console.error('Error while saving vendor:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save vendor. Please try again.',
        });
      },
    });

    this.subscriptions.add(sub);
  }

  onCsvSelect(event: any) {
    const file = event.files[0];
    if (file) {
      this.uploadedCsvFile = file;
      console.log('CSV selected:', file.name);
    }
  }

  downloadSampleCsv() {
    const link = document.createElement('a');
    link.href = environment.APIUrl + '/media/sample_csv/applicant_details.csv';
    link.download = 'Applicant Details';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onCsvUpload(event: any) {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.csvfile = file;
  }
  getTableData() {
    const sub = this.api
      .getAPI(
        `/idex/vendor-details/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`
      )
      .subscribe(
        (res: any) => {
          this.vendorData = res;
          this.vendors = res.vendor_step;
          const vendorSteps = res.vendor_step || [];
          // this.vendors.clear(); // Clear existing form array if any

          vendorSteps.forEach((vendor: any) => {
            // this.vendors.push(this.createVendorFormGroup(vendor));
          });
        },
        (error) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: 'Failed to load schemes'
          // });
        }
      );
    this.subscriptions.add(sub);
  }
  submitCsv() {
    if (!this.csvfile) {
      alert('Please upload a CSV file first.');
      return;
    }

    const formData = new FormData();
    formData.append('step', this.vendorData.id);
    formData.append('file', this.csvfile);

    const sub = this.api.postAPI(`/idex/vendor-details/`, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File  uploaded successfully',
        });
        this.getTableData(); // refresh the table
      },
      error: (err) => {
        console.error('Error while saving vendor:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save vendor. Please try again.',
        });
      },
    });

    this.subscriptions.add(sub);
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  getFileName(url: string | null | undefined): string {
    const fileName = url?.split('/').pop()?.split('?')[0];
    if (!fileName) {
      return '';
    }

    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }
  onSubmit() { }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }
}
